import React from 'react';
import { MyContext } from '../../../contexts/MyContext';
import '../../../css/ventas.css';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import EditarVenta from './EditarVenta';

class Ventas extends React.Component {

    static contextType = MyContext;

    constructor(props) {
        super(props);
        this.state = {
            ventas: [],
            ventaSeleccionada: [],
            showModalEliminar: false,
            showModalEditar: false,
            comentario: '',
        }
    }

    componentDidMount = async () => {
        window.addEventListener('resize', this.getHeightWindow);
        window.addEventListener('beforeunload', this.alertUser);
        this.getHeightWindow();
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'select', sucursal: this.props.idSucursal, fecha: this.props.fecha })
        };
        const response = await fetch('https://admin.panaderialazcano.com/php/DB/ventas.php', requestOptions);
        const data = await response.json();
        this.setState({
            ventas: data
        })
    }

    componentDidUpdate = (prevProps) => {
        if ((prevProps.idSucursal !== this.props.idSucursal) || (prevProps.fecha !== this.props.fecha)) {
            this.componentDidMount();
            this.setState({
                ventaSeleccionada: [],
                comentario: ''
            })
        }
    }
    
    alertUser = (e) => {
        if (this.state.showModalEditar) {
            e.preventDefault();
            e.returnValue = '';  
        }
    }

    numberWithCommas = (x) => {
        x = Number(x).toFixed(2);
        if (x === 0) {
            return '0.00';
        }else{
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }

    getHeightWindow = () => {
        var height = window.innerHeight;
        if (document.getElementsByClassName("containerVentas")[0]) {
            document.getElementsByClassName("containerVentas")[0].style.height = (height - 170) + 'px';
            document.getElementsByClassName("containerDetalleVenta")[0].style.height = (height - 240) + 'px';
        }
    }

    selectVenta = async (e) => {
        let idVenta = e.target.id;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'selectWhere', idVenta: idVenta })
        };
        const response = await fetch('https://pos.panaderialazcano.com/php/DB/ventas.php', requestOptions);
        const data = await response.json();
        this.setState({
            ventaSeleccionada: data[0]
        });
    }

    showModalEditar = () => {
        if (this.state.ventaSeleccionada.idVenta) {                
            this.setState({
                showModalEditar: true
            });
        }else{
            toast.dismiss();
            toast.error('Para eso, seleccione una venta.');
        }
    }

    hideModalEditarUpdate = () => {
        this.setState({
            showModalEditar: false,
            ventaSeleccionada: []
        });
        this.componentDidMount();
    }

    hideModalEditar = () => {
        this.setState({
            showModalEditar: false
        })
    }

    hideModalEliminar = () => {
        this.setState({
            showModalEliminar: false
        });
    }

    showModalEliminar = () => {
        if (this.state.ventaSeleccionada.idVenta) {
            this.setState({
                showModalEliminar: true
            });
        }else{
            toast.dismiss();
            toast.error('Para eso, seleccione una venta.');
        }
    }

    eliminarVenta = async () => {
        if (this.state.comentario !== '') {
            let idVenta = this.state.ventaSeleccionada.idVenta;
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    operacion: 'delete', 
                    usuario: this.context.rootState.theUser.idUsuario,
                    idVenta: idVenta, 
                    comentario: this.state.comentario, 
                    productos: this.state.ventaSeleccionada.productos, 
                    sucursal: this.props.idSucursal 
                })
            };
            const response = await fetch('https://admin.panaderialazcano.com/php/DB/ventas.php', requestOptions);
            const data = await response.json();
            toast.success(data.mensaje);
            this.hideModalEliminar();
            this.componentDidMount();
            this.setState({
                ventaSeleccionada: []
            })
        }else{
            toast.error('Debe escribir un motivo para la eliminación.');
        }
    }

    onChangeValue = (e) => {
        this.setState({
            [e.target.name]: e.target.value 
        });
    }
    
    render() { 
        return ( 
            <>
                <div className="container-fluid ventas">
                    <div className="row">
                        <div className="col-3 px-4 pt-4">
                            <div className="row">
                                <div className='containerVentas' style={{ backgroundColor: '#e1e4c8' }}>
                                    <div className="row py-2" style={{ borderBottom: '5px solid #afc37f' }}>
                                        <div className="col-6 text-center">
                                            Fecha
                                        </div>
                                        <div className="col-6 text-center">
                                            Total
                                        </div>
                                    </div>
                                    {
                                        this.state.ventas[0] ?
                                            this.state.ventas.map((e, index) =>
                                                <div className="row elementoVentas py-3" key={index} id={e.idVenta} onClick={this.selectVenta} style={{ cursor: 'pointer' }}>
                                                    <div className="col-6 text-center" id={e.idVenta}>
                                                        {new Date(e.fecha).toLocaleDateString()}
                                                    </div>
                                                    <div className="col-6 text-end" id={e.idVenta}>
                                                        ${this.numberWithCommas(e.total)}
                                                    </div>
                                                </div>
                                            )
                                            :
                                            <div className="row mt-3">
                                                <div className="col-12 text-center">
                                                    No hay ventas registradas en esta fecha.
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-9 px-4 pt-4">
                            <div className="row">
                                <div className='containerDetalleVenta' style={{ backgroundColor: '#e1e4c8' }}>
                                    <div className="row py-3" style={{ borderBottom: '5px solid #afc37f' }}>
                                        <div className="col-12 text-center">
                                            <h5 className='m-0'>Detalles de la Venta</h5>
                                        </div>
                                    </div>
                                    {
                                        this.state.ventaSeleccionada.idVenta &&
                                            <>
                                                <div className="row" style={{ borderBottom: '5px solid #afc37f' }}>
                                                    <div className="col-6 text-center py-2" style={{ borderRight: '5px solid #afc37f' }}>
                                                        <h6 className='m-0'>Fecha: {new Date(this.state.ventaSeleccionada.fecha).toLocaleDateString()}</h6>
                                                    </div>
                                                    <div className="col-6 text-center py-2">
                                                        <h6 className='m-0'>Total: ${this.numberWithCommas(this.state.ventaSeleccionada.total)}</h6>
                                                    </div>
                                                </div>
                                                {this.state.ventaSeleccionada.productos.map((e, index) => 
                                                    <div className="row py-3" key={index} style={{ borderBottom: '3px solid #afc37f3a' }}>
                                                        <div className="col-4 text-center">
                                                            {e.nombre}
                                                        </div>
                                                        <div className="col-4 text-center">
                                                            {e.cantidad} Pzs.
                                                        </div>
                                                        <div className="col-4 text-center">
                                                            ${this.numberWithCommas(e.precioUnitario)}
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                    }
                                </div>
                            </div>
                            <div className="row pt-4 justify-content-center">
                                <button className='btn btn-secondary me-2 btn-lg w-auto' onClick={this.showModalEditar} hidden={!this.state.ventaSeleccionada.idVenta}>Editar Venta</button>
                                <button className='btn btn-success ms-2 btn-lg btnFinalizarVenta w-auto' onClick={this.showModalEliminar} hidden={!this.state.ventaSeleccionada.idVenta}>Eliminar Venta</button>
                            </div>
                        </div>
                    </div>
                    <Modal show={this.state.showModalEditar} onHide={this.hideModalEditar} fullscreen style={{ backgroundColor: '#e1e4c8' }}>
                        <Modal.Header className='d-flex justify-content-center' style={{ backgroundColor: '#947450', color: 'white' }} closeButton>
                            <h4>Editar Venta</h4>
                        </Modal.Header>
                        <Modal.Body style={{ backgroundColor: '#e1e4c8' }}>
                            <EditarVenta idSucursal={this.props.idSucursal} venta={this.state.ventaSeleccionada} cerrarModal={this.hideModalEditarUpdate}/>
                        </Modal.Body>
                    </Modal>
                    <Modal show={this.state.showModalEliminar} onHide={this.hideModalEliminar} centered>
                        <Modal.Header>
                            <h4>Eliminar Venta</h4>
                        </Modal.Header>
                        <Modal.Body>
                            <label>Motivo de Eliminación:</label>
                            <textarea className='form-control' name="comentario" cols="30" rows="5" value={this.state.comentario} onChange={this.onChangeValue}></textarea>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className='btn btn-secondary' onClick={this.hideModalEliminar}>Cancelar</button>
                            <button className='btn btn-danger' onClick={this.eliminarVenta}>Eliminar</button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </>
         );
    }
}
 
export default Ventas;